module.exports = __webpack_public_path__ + "static/hayee-273dea39003d3029cd7f88ecced9b61f.png";